var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-widget-body widget-progress"},[_c('sf-data-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"rowClassName":_vm.getRowClass,"stripe":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }